export default {
  title: 'Modificateurs',
  master_title: 'Mode marque - Modificateurs',
  products_creation_disabled:
    "En raison de l'intégration active avec {{integration}}, la création de nouveaux produits n'est pas autorisée. Pour modifier le menu, effectuez les changements dans {{integration}} et synchronisez le menu.",
  labels: {
    select_all: 'Tout sélectionner',
  },
  buttons: {
    add_modifier: 'Ajouter un modificateur',
    delete_selected: 'Supprimer la sélection',
    refresh: 'Actualiser',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
